<template>
  <div class="import-dialog">
    <el-dialog
      title="导入风险串号"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="550px"
      top="3%"
      @close="close"
    >
      <div class="import-item">
        <div class="step">
          <div class="step-title">
            <span>Step1</span>
            <span class="cance-tip"
              >请下载模板表格后，按模板维护串号再导入</span
            >
          </div>
          <div class="step-content flex">
            <span>下载模板</span>
            <span class="btn ml-10" @click="download">点击下载模板表格</span>
          </div>
          <div class="step-title">
            <span>Step2</span>
            <span class="cance-tip">可拖拽或选取文件上传</span>
          </div>
          <div class="step-content">
            <el-upload
              ref="uploadBox"
              drag
              :limit="1"
              class="upload-demo"
              :headers="headers"
              :auto-upload="false"
              :http-request="uploadFile"
              :before-upload="beforeAvatarUpload"
              :accept="'.xls,.xlsx'"
              action="customize"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                点击或将文件拖拽到这里上传
                <p style="margin-top: 5px;">
                  请上传.xls或.xlsx格式的excel文件，大小10M内
                </p>
              </div>
            </el-upload>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="close">取消</el-button>
        <el-button type="primary" @click.native="importNext">确认</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="安全验证"
      :visible.sync="commandShow"
      :close-on-click-modal="false"
      width="500px"
      @closed="command = ''"
    >
      <div style="margin-bottom: 20px;">
        <span style="color: #ff8695;font-size: 14px;"
          >导入后，此串号提醒报价师功能将自动开启</span
        >
      </div>
      <div class="tip-centent">
        <span>是否确认导入？</span>
      </div>
      <div class="command">
        <div style="width: max-content">谷歌验证码：</div>
        <el-input
          v-model="command"
          placeholder="请输入谷歌动态口令"
          oninput="this.value = this.value.replace(/[^0-9a-zA-Z]/ig,'')"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="commandShow = false">取消</el-button>
        <el-button
          type="primary"
          @click.native="commandSureImport"
          :loading="commandButLoading"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
import { encryptByDES } from "@/utils/3DES";
import { MessageBox } from "element-ui";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      headers: {
        ACCESS_TOKEN: localStorage.getItem("token"),
        channel: "merchantPc",
        TOKEN: "",
      },
      commandShow: false,
      command: "",
      commandButLoading: false,
    };
  },
  created() {},
  methods: {
    close() {
      this.$emit("close");
    },
    beforeAvatarUpload(file) {
      console.log(file.type);
      this.headers.TOKEN = encryptByDES(
        encryptByDES(
          new Date().getTime().toString(),
          "63e42c2444e94c1ebca21d30d2aa39a5"
        ),
        localStorage.getItem("token") || ""
      );
      const isXls =
        file.type === "application/vnd.ms-excel" ||
        file.type ===
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
      const isLt10M = file.size / 1024 / 1024 < 10;
      if (!isXls) {
        this.$message.error("上传文件只能是.xls或者.xlsx格式!");
      }
      if (!isLt10M) {
        this.$message.error(`上传文件大小不能超过10MB!`);
      }
      return isXls && isLt10M;
    },
    uploadFile(params) {
      const _file = params.file;
      // 通过 FormData 对象上传文件
      var formData = new FormData();
      formData.append("file", _file);
      formData.append("command", this.command);
      this.commandButLoading = true;
      // 发起请求
      _api
        .importRiskNumber(formData)
        .then((res) => {
          if (res.code === 1) {
            this.$message({
              type: "success",
              message: "导入成功",
            });
            this.$emit("importSuccess");
            this.close();
          } else {
            this.$message({
              type: "warning",
              message: res.msg,
            });
          }
          this.commandButLoading = false;
        })
        .catch(() => {
          this.commandButLoading = false;
        });
    },
    importNext() {
      if (this.$refs.uploadBox.uploadFiles.length === 0) {
        this.$message.error("请先上传文件");
        return;
      }
      this.commandShow = true;
    },
    commandSureImport() {
      if(!this.command.trim()){
        return this.$message.error("请输入动态口令");
      }
      this.$refs.uploadBox.submit();
    },
    download() {
      const link = document.createElement("a");
      link.href = "/static/风险串号导入模板.xlsx";
      link.setAttribute("download", "风险串号导入模板.xlsx");
      document.body.appendChild(link);
      link.click();
    },
  },
};
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.import-dialog {
  .flex {
    display: flex;
    align-items: center;
  }
  .cance-tip {
    color: #ff8080;
    font-size: 14px;
    margin-left: 10px;
  }
  .import-item {
    padding: 20px 20px 0 20px;
    background: #f9fbfd;
    box-shadow: 2px 2px 4px 0px rgba(76, 132, 255, 0.15);
    border-radius: 4px;
    border: 1px solid #c1d1ff;
    margin-bottom: 20px;
  }
  .step {
    .step-title {
      color: #0981ff;
      margin-bottom: 10px;
      padding-left: 6px;
      border-left: 3px solid;
      border-radius: 1.5px;
    }

    .step-content,
    .step2-content {
      margin-bottom: 26px;
    }

    .step2-content > div {
      display: flex;
    }

    .step2-content {
      .upload-demo {
        display: flex;
        justify-content: start;

        .el-upload-list {
          width: 200px;
        }
      }
    }

    .tip {
      margin-bottom: 12px;

      .tip-title {
        color: #666666;
        margin-right: 12px;
      }

      .tip-content {
        color: #ff687b;
        font-size: 12px;
      }
    }
  }
  .ml-10 {
    margin-left: 10px;
  }
  .btn {
    text-decoration: underline;
    cursor: pointer;
    color: #0981ff;
  }
  .tip-centent {
    font-size: 16px;
    text-align: center;
    margin-bottom: 20px;
  }
  .command {
    display: flex;
    align-items: center;
    /deep/.el-input {
      width: 300px;
    }
  }
}
</style>
